import { render } from "./RouteAppointmentTypes.vue?vue&type=template&id=1aba385a&ts=true"
import script from "./RouteAppointmentTypes.vue?vue&type=script&lang=ts"
export * from "./RouteAppointmentTypes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__